import ChangeLeaveIssuer from './ChangeLeaveIssuer';

export default ChangeLeaveIssuer;
